/**
 * 状态下拉框
 */

import React, { memo } from 'react';
import { Select, Popover } from 'antd';
import type { SelectProps } from 'antd';
import intl from 'react-intl-universal';
import { STATUS_OPTION } from '@/constants/okr';

const { Option } = Select;

const StatusSelect = (props: SelectProps) => {
  return (
    <Select
      placeholder={intl.get('placeholder.select').d('请选择')}
      style={{ minWidth: 90 }}
      {...props}
      popupMatchSelectWidth={false}
    >
      {STATUS_OPTION.map((i) => (
        <Option key={i.key} value={i.key}>
          <Popover content={i.popover} placement="left" arrow>
            <span
              style={{
                display: 'inline-block',
                width: '100%',
                color: i.color,
                textAlign: 'left',
              }}
            >
              {'● '} {i.label}
            </span>
          </Popover>
        </Option>
      ))}
    </Select>
  );
};

export default memo(StatusSelect);
